import type { Core } from "../../..";

interface Parser {
	parse(schema: unknown, config: Core.Config): string;
}

class AutoTypes {
	private parser?: Parser;

	setParser(parser: Parser) {
		this.parser = parser;
	}

	parse(schema: unknown, config: Core.Config) {
		return this.parser?.parse(schema, config) || "";
	}
}

/**
 * Parse a list of schemas with their corresponding parsers and return an array
 * with each parsed schema as string.
 * @example
 * const output = parseSchemas([
 *     { schema: languages, parser: parsers.LanguagesParser },
 *     { schema: menuItems, parser: parsers.MenuItemsParser },
 * ])
 * // returns ["language-schema-parsed", "menu-items-schema-parsed"]
 */
function parseSchemas(
	schemaParserMap: Array<{
		schema: unknown;
		parser: new () => Parser;
		config: Core.Config;
	}>,
) {
	const AutoTypesParser = new AutoTypes();
	return schemaParserMap.map((entry) => {
		AutoTypesParser.setParser(new entry.parser());
		return AutoTypesParser.parse(entry.schema, entry.config);
	});
}

export { AutoTypes, Parser, parseSchemas };
